module.exports = __webpack_public_path__ + "img/building1.6fba3ffe.png";